/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ConditionType = {
    LOGO_MATCH: 'LOGO_MATCH',
    OBJECT_MATCH: 'OBJECT_MATCH',
    OBJECT_NO_MATCH: 'OBJECT_NO_MATCH',
    LABEL_MATCH: 'LABEL_MATCH',
    LABEL_NO_MATCH: 'LABEL_NO_MATCH',
    CUSTOM: 'CUSTOM',
    TEXT_MATCH: 'TEXT_MATCH',
    TEXT_NO_MATCH: 'TEXT_NO_MATCH',
    LEVENSHTEIN_MATCH: 'LEVENSHTEIN_MATCH'
} as const;
export type ConditionType = typeof ConditionType[keyof typeof ConditionType];


export function instanceOfConditionType(value: any): boolean {
    for (const key in ConditionType) {
        if (Object.prototype.hasOwnProperty.call(ConditionType, key)) {
            if (ConditionType[key as keyof typeof ConditionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ConditionTypeFromJSON(json: any): ConditionType {
    return ConditionTypeFromJSONTyped(json, false);
}

export function ConditionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConditionType {
    return json as ConditionType;
}

export function ConditionTypeToJSON(value?: ConditionType | null): any {
    return value as any;
}

export function ConditionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ConditionType {
    return value as ConditionType;
}

